import { apiClient } from "services/api-client"

// Relatórios ROPA
export const getReportRopa = async (companyKey) => {
    return await apiClient.get(`/mapping/report-ropa?companyKey=${companyKey}`)
}

export const generateReportRopa = async (data) => {
    return await apiClient.post('/mapping/report-ropa', data)
}

// Bases Legais
export const getLegalBases = async (companyKey) => {
    return await apiClient.get(`/mapping/legal-bases?companyKey=${companyKey}`)
}

// Categorias de Dados
export const getDataCategories = async (companyKey) => {
    return await apiClient.get(`/mapping/data-categories?companyKey=${companyKey}`)
}

// Health Check
export const healthCheck = async () => {
    return await apiClient.get('/healthcheck')
}